import axios from 'axios';
import config from '../../config';
import { goTo } from '../../actions/routing';
import { formatFormData } from '../../utils/formData';
import { FEATURE_CODES } from '../../constants/constants';
import { getErrorConfig } from '../../utils/error-code';

export const FORGET_USERNAME_ON_HIDE_ALERT = 'FORGET_USERNAME_ON_HIDE_ALERT';
export const FORGET_USERNAME_CARD_SUBMIT = 'FORGET_USERNAME_CARD_SUBMIT';
export const FORGET_USERNAME_CARD_SUBMIT_FAIL = 'FORGET_USERNAME_CARD_SUBMIT_FAIL';
export const FORGET_USERNAME_CARD_SUBMIT_NOT_FOUND_FAIL = 'FORGET_USERNAME_CARD_SUBMIT_NOT_FOUND_FAIL';
export const POLICY_NO_SUBMIT = 'POLICY_NO_SUBMIT';
export const CERT_NO_SUBMIT = 'CERT_NO_SUBMIT';
export const MEMBERSHIP_NO_SUBMIT = 'MEMBERSHIP_NO_SUBMIT';
export const CONTACT_US = 'CONTACT_US';
export const SUBMIT_ENQUIRY = 'SUBMIT_ENQUIRY';
export const FORGET_INITIAL = 'FORGET_INITIAL'; 
export const SUBMIT_RESET = 'SUBMIT_RESET';
export const HSBC_POLICY = 'FORGET_USERNAME_HSBC_POLICY';
const SUBMIT_PENDING = 'SUBMIT_PENDING';
const SERVER_REQUEST_PENDING = 'myaxa/forgetUsername/SERVER_REQUEST_PENDING';
// const SERVER_REQUEST_COMPLETE = 'myaxa/forgetUsername/SERVER_REQUEST_COMPLETE';

const initialState = {
  method: 'email',
  showAlert: false,
  showError: false,
  userData: {},
  error: '',
  resetUsernameComplete: false,
  verifyTokenComplete: false,
  serverStatus: '',
  isSubmitting: false,
  policyInput: '',
  isLoading: false,
  errorCode: '',
  payload: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FORGET_INITIAL:
      return {
        ...state,
        showAlert: false,
        isSubmitSuccess: false,
      };
    case POLICY_NO_SUBMIT:
    case CERT_NO_SUBMIT:
    case MEMBERSHIP_NO_SUBMIT:
      return {
        ...state,
        showAlert: false,
      };
    case FORGET_USERNAME_CARD_SUBMIT:
      return {
        ...state,
        hash: action.hash,
        isSubmitting: false,
      };
    case FORGET_USERNAME_CARD_SUBMIT_NOT_FOUND_FAIL:
    case FORGET_USERNAME_CARD_SUBMIT_FAIL:
      return {
        certificateNumber: action.certificateNumber,
        policyNo: action.policyNo,
        dependentNumber: action.dependentNumber,
        membershipNo: action.membershipNo,
        isSubmitting: false,
        errorCode: action.errorCode,
      };
    case FORGET_USERNAME_ON_HIDE_ALERT:
      return {
        ...state,
        showError: false,
        showAlert: false,
        error: '',
      };
    case SUBMIT_PENDING: {
      return {
        ...state,
        isSubmitting: true,
      };
    }
    case SUBMIT_RESET:
      return {
        ...state,
        isSubmitting: false,
        errorCode: action.errorCode,
        payload: action.data,
      };
    case HSBC_POLICY:
      return {
        ...state,
        policyInput: action.policyInput,
      };
    case CONTACT_US:
      return {
        ...state,
        chinaId: action.chinaId,
        hkId: action.hkId,
        passport: action.passport,
        certificateNumber: action.certificateNumber,
        dependentNumber: action.dependentNumber,
        membershipNo: action.membershipNo,
        isLoading: false,
      };
    case SUBMIT_ENQUIRY:
      return {
        ...state,
        isLoading: false,
      };
    case SERVER_REQUEST_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    default:
      return state;
  }
}

export const onPolicyNumberSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: POLICY_NO_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/axa-cn`));
  };
};

export const onCertNumberSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: CERT_NO_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/ebDob`));
  };
};

export const onMembershipNumberSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: MEMBERSHIP_NO_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/ebDob`));
  };
};

export const onCardSubmit = (query) => {
  return async (dispatch, getState) => {
    const details = {
      'policyType': query.policyType,
      'cardType': query.cardType,
      'policy': query.policyNo,
      'cert': query.certificateNumber,
      'dependent': query.dependentNumber,
      'member': query.membershipNo,
      'dob': query.dob,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SUBMIT_PENDING,
    });

    dispatch({
      type: SERVER_REQUEST_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/customer/eb/search`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      dispatch({
        type: SUBMIT_ENQUIRY,
      });
      if (!response.data.checkHash) {
        // no check hash return from server
        dispatch({
          type: FORGET_USERNAME_CARD_SUBMIT_NOT_FOUND_FAIL,
          certificateNumber: query.certificateNumber,
          policyNo: query.policyNo,
          dependentNumber: query.dependentNumber,
          membershipNo: query.membershipNo,
          errorCode: response.data.code,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
      } else if (!response.data.axaId) {
        // no axaId return from server
        dispatch({
          type: FORGET_USERNAME_CARD_SUBMIT_FAIL,
          errorCode: response.data.code,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
      } else if (response.data.iam) {
        if (response.data.iam.status.toLowerCase() === 'pre-validated') {
          // account not activate
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/prevalidated`));
        } else if (response.data.iam.status.toLowerCase() === 'active') {
          // normal scenario
          dispatch({
            type: FORGET_USERNAME_CARD_SUBMIT,
            hash: response.data.checkHash,
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/setup-account`));
        }
      } else { // fail case
        dispatch({
          type: FORGET_USERNAME_CARD_SUBMIT_FAIL,
          certificateNumber: query.certificateNumber,
          policyNo: query.policyNo,
          dependentNumber: query.dependentNumber,
          membershipNo: query.membershipNo,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
      }
    }).catch((error) => {
      // CUSEXP1, CUSEXP2, CUSEXP3, CUSEXP4, CUSEXP5, CUSEXP7, CUSEXP
      dispatch({
        type: FORGET_USERNAME_CARD_SUBMIT_FAIL,
        certificateNumber: query.certificateNumber,
        policyNo: query.policyNo,
        dependentNumber: query.dependentNumber,
        membershipNo: query.membershipNo,
        errorCode: error.response.data.code,
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/not-registered`));
    });
  };
};

export const submitCreateUsername = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const details = {
      'checkHash': submitValues.hash,
      'contactType': submitValues.contactType,
      'email': submitValues.email,
      'countryCode': submitValues.countryCode,
      'mobile': submitValues.mobile,
      'locale': `${getState().language.lang}`,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SUBMIT_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/account/reset`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(() => {
      dispatch({
        type: SUBMIT_RESET,
        errorCode: '',
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/setup-success`));
    }).catch((error) => {
      dispatch({
        type: SUBMIT_RESET,
        errorCode: error.response.data.code,
        payload: error.response.data.payload,
      });

      const errorConfig = getErrorConfig({
        apiCode: error.response.data.code,
        featureCode: FEATURE_CODES.forgetUsername,
      });

      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/username/setup-fail?errorCode=${errorConfig.errorCode}&fromPage=${encodeURIComponent(fromPage)}`));
    });
  };
};

export const onContactUs = (query) => {
  return async (dispatch, getState) => {
    dispatch({
      type: CONTACT_US,
      chinaId: query.chinaId,
      hkId: query.hkId,
      passport: query.passport,
      policyNo: query.policyNo,
      certificateNumber: query.certificateNumber,
      dependentNumber: query.dependentNumber,
      membershipNo: query.membershipNo,
    });

    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/contact-us`));
  };
};

export const onSubmitEnquiry = () => {
  return async (dispatch, getState) => {
    // TODO Submit Query API
    dispatch({
      type: SUBMIT_ENQUIRY,
    });

    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/forget/contact-us-success`));
  };
};

export const modalClose = () => {
  return (dispatch) => {
    dispatch({
      type: FORGET_USERNAME_ON_HIDE_ALERT,
    });
  };
};

